import { Fragment, useMemo, useState } from "react";

import { Message } from "../constants/types";

import {
    formSelectContainer,
    formSelectOption,
    formSelectLine2,
    formSelectOptionIcon
} from "./form-select-option.styles";

export const FormSelectOption = ({
    option,
    simplifiedView,
    lastSelectedOn,
    assetResolver = () => undefined
}: FormSelectOptionProps) => {
    const icon = assetResolver(option.value, {} as Message, false);

    const [hideDetails] = useState(simplifiedView);

    let viewOption = (
        <div css={formSelectOption}>
            <div css={formSelectOptionIcon}>{icon}</div>
            <div>
                <span>{option.label}</span>
                {option.description && (
                    <Fragment>
                        <br />
                        <span css={formSelectLine2}>{option.description}</span>
                    </Fragment>
                )}
            </div>
        </div>
    );

    if (hideDetails) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        viewOption = useMemo(
            () => (
                <div css={formSelectOption}>
                    <span>{option.label}</span>
                </div>
            ),
            [lastSelectedOn]
        );
    }

    return <div css={formSelectContainer}>{viewOption}</div>;
};

type FormSelectOptionProps = {
    option: { value: string; label: string; description?: string };
    simplifiedView?: boolean;
    lastSelectedOn: string;
    assetResolver?: (
        value: string,
        messages: Message,
        includeLabel: boolean
    ) => JSX.Element | undefined;
};
